module.exports = __webpack_public_path__ + "static/media/46.417c9b9a.png";